import React from 'react';
import { IconButton, Stack, Typography, Box } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HotelIcon from '@mui/icons-material/Hotel';
import TrainingPlanWorkoutListItem from './TrainingPlanWorkoutListItem';

const dayOfWeek = (day) => {
  return day % 7 === 0 ? 7 : day % 7;
};

export default function TrainingPlanScheduleDay({
  events,
  onOpenAddWorkout,
  onRemove,
  day,
  weekday,
}) {
  const dayEvents = (events ?? []).filter(Boolean);
  const hasEvents = dayEvents.length > 0;
  const primaryEvent = dayEvents[0];
  const title = primaryEvent?.title ?? 'Rest Day';
  const isConditioning = /conditioning|cardio/i.test(title);
  const isRecovery = /recovery|mobility/i.test(title);
  const type = !hasEvents
    ? 'rest'
    : isConditioning
    ? 'conditioning'
    : isRecovery
    ? 'recovery'
    : 'workout';
  const meta =
    type === 'rest'
      ? ['-', 'Rest']
      : type === 'conditioning'
      ? ['30 min', 'Cardio']
      : type === 'recovery'
      ? ['20 min', 'Mobility']
      : ['45 min', '8 exercises'];
  const iconSx = {
    width: 24,
    height: 24,
    borderRadius: '50%',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 auto',
  };
  const icon =
    type === 'rest' ? (
      <Box sx={{ ...iconSx, backgroundColor: '#e8edf5', color: '#63758d' }}>
        <HotelIcon sx={{ fontSize: 15 }} />
      </Box>
    ) : type === 'conditioning' ? (
      <Box sx={{ ...iconSx, backgroundColor: '#f97316' }}>
        <DirectionsRunIcon sx={{ fontSize: 15 }} />
      </Box>
    ) : type === 'recovery' ? (
      <Box sx={{ ...iconSx, backgroundColor: '#4f94ff' }}>
        <AccessTimeIcon sx={{ fontSize: 15 }} />
      </Box>
    ) : (
      <Box sx={{ ...iconSx, backgroundColor: '#7357ee' }}>
        <FitnessCenterIcon sx={{ fontSize: 15 }} />
      </Box>
    );

  return (
    <Box sx={{ height: '100%', p: 1.5 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1.25 }}
      >
        <Box>
          <Typography sx={{ color: '#0f1d2d', fontWeight: 700, fontSize: 12 }}>
            {weekday ?? `Day ${dayOfWeek(day)}`}
          </Typography>
          <Typography sx={{ color: '#33445a', fontSize: 12 }}>
            Day {day}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onOpenAddWorkout}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Stack>

      {hasEvents ? (
        <Stack spacing={1}>
          {dayEvents.map((event, index) => (
            <TrainingPlanWorkoutListItem
              key={event._id ?? event.objectId ?? `${day}-${index}`}
              workout={event}
              move={true}
              onRemove={onRemove}
              variant="schedule"
              icon={icon}
              meta={meta}
            />
          ))}
        </Stack>
      ) : (
        <Box>
          <Stack direction="row" spacing={1} alignItems="center">
            {icon}
            <Typography sx={{ fontWeight: 800, fontSize: 14 }}>
              Rest Day
            </Typography>
          </Stack>
          <Typography sx={{ color: '#506176', fontSize: 13, mt: 1 }}>
            -
          </Typography>
          <Typography sx={{ color: '#506176', fontSize: 13 }}>Rest</Typography>
        </Box>
      )}
    </Box>
  );
}
